import {styled} from '@mui/material';

const StyledDotButton = styled('div')`
	background-color: ${({theme}) => theme.palette.action.hover};
	width: 8px;
	height: 8px;
	border-radius: 50%;
`;

const DotsContainer = styled('div')`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	margin-top: 8px;
	padding-inline: 24px;
`;

const StyledImage = styled('img')`
	width: 100%;
	border-radius: 16px;
	${({theme}) => theme.breakpoints.down('sm')} {
		border-radius: 4px;
	}
`;

const StyledLink = styled('a')`
	display: flex;
	height: 100%;
`;

export {StyledDotButton, DotsContainer, StyledImage, StyledLink};
